/* ============================================================
   Wall Designer v3 — port of the Claude Design handoff
   ("Wall Designer - Standalone (3)").

   v3 over v2: true wall dimensions per preset room (canvas letterboxed
   to the wall's aspect), wall-colour override, catalog with All Prints /
   Collections / Filters views (filter accordion: collection, size,
   artist, orientation, colours), square artwork support, white-border
   Yes/No for open editions (maps to the store's "White Border" line-item
   property), LE edition numbers on the signature strip, non-overlapping
   placement, and proportional re-positioning when the wall changes.

   Product data injected by sections/wall-designer.liquid:
     [data-wd-products] — LE + open products (variants, collections, tags)
     [data-wd-frames]   — LE frame product variants (Color × Size)

   Cart mapping:
   - Limited edition: art variant (Size) + frame variant (Color × Size)
     as two line items when framed; art variant only when unframed.
   - Open edition: variant matched by Size prefix + Frame value, with a
     properties["White Border"] = Yes/No line-item property.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('wall-designer');
  if (!root) return;

  function readJson(sel) {
    var el = document.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var PRODUCTS = readJson('[data-wd-products]') || [];
  var FRAMES = readJson('[data-wd-frames]') || [];

  // ---------- static data (from the design) ----------
  var SIZES = [
    { name: 'Mini',      pw: 21,    ph: 29.7,  iw: 14.7,  ih: 20.8,  mw: 16.3, mh: 22.4,  fw: 24,   fh: 33,   frW: 2,    sig: 0.8 },
    { name: 'Small',     pw: 29.7,  ph: 42,    iw: 20.8,  ih: 29.4,  mw: 22.8, mh: 31.4,  fw: 33,   fh: 45.4, frW: 2,    sig: 1 },
    { name: 'Medium',    pw: 42,    ph: 59.4,  iw: 29.4,  ih: 41.6,  mw: 31.4, mh: 43.6,  fw: 46,   fh: 63.5, frW: 3,    sig: 1 },
    { name: 'Large',     pw: 59.4,  ph: 84.1,  iw: 47.5,  ih: 67.3,  mw: 49.9, mh: 69.7,  fw: 63.5, fh: 88,   frW: 3,    sig: 1.2 },
    { name: 'X-Large',   pw: 70.7,  ph: 100,   iw: 56.6,  ih: 80,    mw: 59.4, mh: 82.8,  fw: 75,   fh: 105,  frW: 3,    sig: 1.4 },
    { name: 'Gallery',   pw: 84.1,  ph: 118.9, iw: 67.3,  ih: 95.1,  mw: 70.5, mh: 98.3,  fw: 89,   fh: 124,  frW: 3,    sig: 1.6 },
    { name: 'Grand',     pw: 101.6, ph: 143.7, iw: 81.3,  ih: 114.9, mw: 84.9, mh: 118.5, fw: 106,  fh: 157,  frW: 3,    sig: 1.8 },
    { name: 'Collector', pw: 127,   ph: 179.6, iw: 108,   ih: 152.7, mw: null, mh: null,  fw: null, fh: null, frW: null, sig: null },
    { name: 'Statement', pw: 152.4, ph: 215.5, iw: 129.5, ih: 183.2, mw: null, mh: null,  fw: null, fh: null, frW: null, sig: null }
  ];
  var FIN = {
    oak:   { label: 'Natural',  color: 'Natural', bg: '#BE9558', edge: 'none' },
    white: { label: 'White',    color: 'White',   bg: '#F6F4F0', edge: '1px solid #D9D4C2' },
    black: { label: 'Black',    color: 'Black',   bg: '#1C1B19', edge: 'none' },
    none:  { label: 'Unframed', color: null,      bg: '#FFFFFF', edge: '1px solid #D9D4C8' }
  };
  var FIN_KEYS = ['oak', 'white', 'black', 'none'];
  var PRESETS = [
    { label: 'Studio',      wall: '#F1EFEB', floor: '#E3DFD5', sw: '#F1EFEB', wcm: 1000, hcm: 800, kit: 'plinth',  blurb: 'A tall, wide wall — suited for our largest sizes, including Grand, Collector and Statement.' },
    { label: 'Living room', wall: '#EDE7DC', floor: '#DCD3C2', sw: '#EDE7DC', wcm: 750,  hcm: 280, kit: 'sofa',    blurb: 'A standard living-room wall — good for a single hero piece above the sofa or a small grouping.' },
    { label: 'Console',     wall: '#E4E6DF', floor: '#D3D6CB', sw: '#E4E6DF', wcm: 500,  hcm: 280, kit: 'console', blurb: 'A narrower console wall — best for Mini through Medium prints, alone or in a small cluster.' },
    { label: 'Bedroom',     wall: '#EBE5E0', floor: '#DDD4CC', sw: '#EBE5E0', wcm: 500,  hcm: 280, kit: 'bed',     blurb: 'A bedroom wall above the headboard — suited for a single medium-to-large piece, or a diptych.' }
  ];
  var KIT_C = { wood: '#C9BFAC', dark: '#B8AF9E', leaf: '#C4C6B4', shade: '#CBC5B8', linen: '#EDEAE3' };
  var KITS = {
    plinth: [
      { cx: -5, y: 0, w: 80, h: 46, bg: '#FBFAF8' }, { cx: 60, y: 0, w: 46, h: 60, bg: '#FBFAF8' },
      { cx: -25, y: 46, w: 26, h: 4, bg: KIT_C.wood }, { cx: -25, y: 50, w: 22, h: 3.4, bg: KIT_C.dark },
      { cx: 60, y: 60, w: 11, h: 11, bg: KIT_C.dark, r: '50%' }
    ],
    sofa: [
      { cx: -98, y: 0, w: 4, h: 12, bg: KIT_C.dark }, { cx: 98, y: 0, w: 4, h: 12, bg: KIT_C.dark },
      { cx: 0, y: 42, w: 220, h: 43, bg: '#D9D4C8', r: '10px 10px 0 0' }, { cx: 0, y: 12, w: 220, h: 32, bg: '#D9D4C8', r: '4px' },
      { cx: -100, y: 12, w: 20, h: 56, bg: KIT_C.shade, r: '8px 8px 0 0' }, { cx: 100, y: 12, w: 20, h: 56, bg: KIT_C.shade, r: '8px 8px 0 0' },
      { cx: -30, y: 44, w: 40, h: 22, bg: KIT_C.linen, r: '4px' }
    ],
    console: [
      { cx: -50, y: 0, w: 4, h: 9, bg: KIT_C.dark }, { cx: 50, y: 0, w: 4, h: 9, bg: KIT_C.dark },
      { cx: 0, y: 9, w: 160, h: 55, bg: KIT_C.wood, r: '3px' },
      { cx: 55, y: 64, w: 10, h: 15, bg: KIT_C.dark }, { cx: 55, y: 76, w: 19, h: 17, bg: KIT_C.leaf, r: '50%' },
      { cx: -40, y: 64, w: 14, h: 3, bg: KIT_C.dark }
    ],
    bed: [
      { cx: 0, y: 8, w: 196, h: 88, bg: KIT_C.shade, r: '6px 6px 0 0' }, { cx: 0, y: 8, w: 190, h: 25, bg: '#D9D4C8', r: '3px' },
      { cx: 0, y: 33, w: 190, h: 18, bg: '#E3DFD5', r: '4px' },
      { cx: -60, y: 51, w: 40, h: 14, bg: KIT_C.linen, r: '4px' }, { cx: 60, y: 51, w: 40, h: 14, bg: KIT_C.linen, r: '4px' }
    ]
  };
  var WALL_COLORS = ['#FFFFFF', '#F1EFEB', '#EDE7DC', '#E4E6DF', '#EBE5E0', '#E0DAD2', '#3A3835'];
  var COLOR_PALETTE = { blue: '#9FAEB8', green: '#A9B5A5', sand: '#C9BFAC', terracotta: '#C4AF9E', yellow: '#D2CBA8', pink: '#D8B8B4', black: '#3A3835', white: '#F3F1EC', orange: '#D2A176', red: '#B96A5A' };

  // Derive per-product colour keys from tags ("colour:blue" / "color:blue" / bare palette word)
  PRODUCTS.forEach(function (p) {
    p.colorKeys = [];
    String(p.tags || '').split('|').forEach(function (t) {
      t = t.trim();
      var m = t.match(/^colou?r:\s*(.+)$/);
      var key = m ? m[1].trim() : (COLOR_PALETTE[t] ? t : null);
      if (key && COLOR_PALETTE[key] && p.colorKeys.indexOf(key) < 0) p.colorKeys.push(key);
    });
  });
  var AVAILABLE_COLORS = [];
  PRODUCTS.forEach(function (p) { p.colorKeys.forEach(function (k) { if (AVAILABLE_COLORS.indexOf(k) < 0) AVAILABLE_COLORS.push(k); }); });
  var VENDORS = [];
  PRODUCTS.forEach(function (p) { if (p.vendor && VENDORS.indexOf(p.vendor) < 0) VENDORS.push(p.vendor); });
  var COLLECTIONS = [];
  PRODUCTS.forEach(function (p) {
    (p.cols || []).forEach(function (c) {
      if (!COLLECTIONS.some(function (x) { return x.h === c.h; })) COLLECTIONS.push(c);
    });
  });
  COLLECTIONS.sort(function (a, b) { return a.t < b.t ? -1 : 1; });

  // ---------- state ----------
  var st = {
    items: [], sel: null, nextId: 1,
    search: '', catView: 'all', catCollection: '',
    filterOpen: { collection: true, size: true, artist: true, orientation: true, colors: true },
    filterEd: [], filterSize: [], filterArtist: [], filterOrient: [], filterColor: [],
    bg: 0, customWallWcm: 400, customBgUrl: null, wallColor: null,
    measure: null,
    canvasW: 900, canvasH: 560,
    shared: false, cartAdded: false, cartBusy: false, dlOpen: false
  };
  var drag = null;

  // ---------- helpers ----------
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
  function money(cents) { return '$' + Math.round(cents / 100).toLocaleString('en-US'); }
  function wallWcm() { return st.bg >= PRESETS.length ? st.customWallWcm : PRESETS[st.bg].wcm; }
  function wallHcmFor(bg, wcm) { return bg >= PRESETS.length ? (wcm != null ? wcm : st.customWallWcm) * 0.62 : PRESETS[bg].hcm; }
  function ppcm() { return st.canvasW / wallWcm(); }

  // Variant lookups ---------------------------------------------------------
  function leArtVariant(prod, sizeName) {
    return prod.variants.filter(function (v) { return v.o1 === sizeName; })[0] || null;
  }
  function leFrameVariant(sizeName, finKey) {
    var color = FIN[finKey] && FIN[finKey].color;
    if (!color) return null;
    return FRAMES.filter(function (v) { return v.o1 === color && v.o2 === sizeName; })[0] || null;
  }
  function openFrameValue(finKey, ftype) {
    if (finKey === 'none') return 'Print Only';
    return FIN[finKey].color + (ftype === 'box' ? ' Box' : '');
  }
  function openVariant(prod, sizeName, finKey, ftype) {
    var fv = openFrameValue(finKey, ftype);
    return prod.variants.filter(function (v) {
      return v.o1 && v.o1.indexOf(sizeName) === 0 && v.o2 === fv && Number(v.p) > 0;
    })[0] || null;
  }
  function sizesFor(prod) {
    return SIZES.map(function (s, i) { return { s: s, i: i }; }).filter(function (x) {
      if (prod.ed === 'limited') return !!leArtVariant(prod, x.s.name);
      return prod.variants.some(function (v) { return v.o1 && v.o1.indexOf(x.s.name) === 0 && Number(v.p) > 0; });
    });
  }
  function finAvailable(prod, sizeName, finKey, ftype) {
    var size = SIZES.filter(function (s) { return s.name === sizeName; })[0];
    if (prod.ed === 'limited') {
      if (finKey === 'none') return !!leArtVariant(prod, sizeName);
      if (!size || size.fw == null) return false;
      return !!(leArtVariant(prod, sizeName) && leFrameVariant(sizeName, finKey));
    }
    return !!openVariant(prod, sizeName, finKey, ftype);
  }
  function itemPrice(it) {
    var prod = PRODUCTS[it.art], size = SIZES[it.sizeIdx];
    if (prod.ed === 'limited') {
      var av = leArtVariant(prod, size.name);
      var total = av ? Number(av.p) : 0;
      if (it.fin !== 'none') { var fv = leFrameVariant(size.name, it.fin); if (fv) total += Number(fv.p); }
      return total;
    }
    var v = openVariant(prod, size.name, it.fin, it.ftype);
    return v ? Number(v.p) : 0;
  }
  function itemCartLines(it) {
    var prod = PRODUCTS[it.art], size = SIZES[it.sizeIdx], lines = [];
    if (prod.ed === 'limited') {
      var av = leArtVariant(prod, size.name);
      if (av) lines.push({ id: av.id, quantity: 1 });
      if (it.fin !== 'none') { var fv = leFrameVariant(size.name, it.fin); if (fv) lines.push({ id: fv.id, quantity: 1 }); }
    } else {
      var v = openVariant(prod, size.name, it.fin, it.ftype);
      if (v) lines.push({ id: v.id, quantity: 1, properties: { 'White Border': it.border !== false ? 'Yes' : 'No' } });
    }
    return lines;
  }
  function minPrice(prod) {
    var ps = prod.variants.map(function (v) { return Number(v.p); }).filter(function (p) { return p > 0; });
    return ps.length ? Math.min.apply(null, ps) : 0;
  }

  // Geometry (cm) — v3 frameGeom with square + white-border support ---------
  function frameGeom(it) {
    var g = SIZES[it.sizeIdx];
    var prod = PRODUCTS[it.art];
    var horiz = prod.orient === 'h', sq = prod.orient === 'sq';
    function sw(a, b) { return sq ? [Math.min(a, b), Math.min(a, b)] : (horiz ? [b, a] : [a, b]); }
    if (prod.ed === 'limited') {
      if (it.fin === 'none' || g.fw == null) {
        var p1 = sw(g.pw, g.ph), i1 = sw(g.iw, g.ih);
        var margin = (p1[0] - i1[0]) / 2;
        var sigBand = g.sig != null ? g.sig : margin * 0.3;
        return { w: p1[0], h: p1[1], framePad: 0, matW: p1[0], matH: p1[1], matPad: margin, sigBand: sigBand, mat: false };
      }
      var f = sw(g.fw, g.fh), m = sw(g.mw, g.mh);
      return { w: f[0], h: f[1], framePad: g.frW, matW: m[0], matH: m[1], matPad: g.sig, sigBand: g.sig, mat: true };
    }
    var p = sw(g.pw, g.ph);
    var hasBorder = it.border !== false;
    var bord = hasBorder ? Math.min(p[0], p[1]) * 0.075 : 0;
    if (it.fin === 'none') {
      return { w: p[0], h: p[1], framePad: 0, matW: p[0], matH: p[1], matPad: bord, mat: false };
    }
    var face = g.frW || 3;
    return { w: p[0] + 2 * face, h: p[1] + 2 * face, framePad: face, matW: p[0], matH: p[1], matPad: bord, mat: false };
  }

  // ---------- render ----------
  var app, wrapEl, canvasEl;

  function recomputeBox() {
    if (!wrapEl) return false;
    var ow = Math.min(wrapEl.clientWidth || 900, 1320);
    var oh = Math.min(wrapEl.clientHeight || 560, 760);
    var custom = st.bg >= PRESETS.length;
    var bw, bh;
    if (custom) { bw = ow; bh = oh; }
    else {
      var scale = Math.min(ow / PRESETS[st.bg].wcm, oh / PRESETS[st.bg].hcm);
      bw = PRESETS[st.bg].wcm * scale; bh = PRESETS[st.bg].hcm * scale;
    }
    bw = Math.round(bw); bh = Math.round(bh);
    if (bw > 0 && bh > 0 && (bw !== st.canvasW || bh !== st.canvasH)) { st.canvasW = bw; st.canvasH = bh; return true; }
    return false;
  }

  function catalogList() {
    var q = st.search.toLowerCase();
    return PRODUCTS.map(function (p, i) { return { p: p, i: i }; }).filter(function (x) {
      if (st.filterEd.length && st.filterEd.indexOf(x.p.ed) < 0) return false;
      if (st.filterOrient.length && st.filterOrient.indexOf(x.p.orient) < 0) return false;
      if (st.filterArtist.length && st.filterArtist.indexOf(x.p.vendor) < 0) return false;
      if (st.filterColor.length && !x.p.colorKeys.some(function (k) { return st.filterColor.indexOf(k) >= 0; })) return false;
      if (st.catView === 'collections' && st.catCollection && !(x.p.cols || []).some(function (c) { return c.h === st.catCollection; })) return false;
      if (q && x.p.title.toLowerCase().indexOf(q) < 0) return false;
      return true;
    });
  }
  function catalogGridHtml() {
    var cat = catalogList();
    return cat.map(function (x) {
      return '<div><div style="position:relative;aspect-ratio:4/5;background:#F1EFEB;overflow:hidden;">' +
        '<img src="' + esc(x.p.img) + '" alt="' + esc(x.p.title) + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;">' +
        (x.p.ed === 'limited' ? '<div style="position:absolute;top:8px;left:8px;background:#fff;padding:4px 8px;font-size:8.5px;letter-spacing:0.18em;text-transform:uppercase;color:#A38B5F;border:1px solid #E5DCC9;pointer-events:none;">Limited Edition</div>' : '') +
        '</div>' +
        '<div style="font-size:12.5px;font-weight:600;padding:8px 0 1px;">' + esc(x.p.title) + '</div>' +
        '<div style="font-size:11px;color:#8A8680;padding-bottom:2px;">' + esc(x.p.vendor) + '</div>' +
        '<div style="font-size:11.5px;color:#8A8680;padding-bottom:8px;">From ' + money(minPrice(x.p)) + '</div>' +
        '<button type="button" class="wd2-addbtn" data-wd-add="' + x.i + '">+ Add to wall</button></div>';
    }).join('') || '<div style="grid-column:1/-1;color:#B0ABA2;font-size:12.5px;">No prints found.</div>';
  }

  function itemHtml(it) {
    var g = frameGeom(it);
    var prod = PRODUCTS[it.art];
    var f = FIN[it.fin];
    var k = ppcm();
    var px = function (v) { return Math.round(v * k * 10) / 10 + 'px'; };
    var sigBand = g.sigBand || g.matPad;
    var sigSize = Math.max(3, Math.round(sigBand * k * 0.38 * 10) / 10);
    var sig = prod.ed === 'limited'
      ? '<div style="position:absolute;left:' + px(g.matPad) + ';right:' + px(g.matPad) + ';bottom:' + px(Math.max(0, g.matPad - sigBand)) + ';height:' + px(sigBand) + ';display:flex;align-items:center;justify-content:space-between;font-size:' + sigSize + 'px;line-height:1;color:#55524D;white-space:nowrap;overflow:hidden;gap:' + Math.max(2, Math.round(sigBand * k * 0.18)) + 'px;"><span>' + (it.editionNum || 1) + '/150</span><span style="letter-spacing:0.14em;text-transform:uppercase;">' + esc(prod.title) + '</span><span style="font-family:var(--heading-font-family,serif);font-style:italic;">' + esc(prod.vendor) + '</span></div>'
      : '';
    return '<div class="wd2-item" data-wd-item="' + it.id + '" style="position:absolute;left:' + px(it.x) + ';top:' + px(it.y) + ';width:' + px(g.w) + ';height:' + px(g.h) + ';background:' + f.bg + ';border:' + (it.fin === 'none' ? '1px solid #D9D4C8' : f.edge) + ';padding:' + px(g.framePad) + ';box-shadow:0 ' + Math.max(6, Math.round(g.h * k * 0.05)) + 'px ' + Math.max(16, Math.round(g.h * k * 0.11)) + 'px -8px rgba(17,17,17,0.5);cursor:grab;outline:' + (st.sel === it.id ? '2px solid #A38B5F' : 'none') + ';outline-offset:3px;box-sizing:border-box;">' +
      '<div style="width:100%;height:100%;background:#fff;display:flex;align-items:center;justify-content:center;pointer-events:none;">' +
        '<div style="position:relative;width:' + px(g.matW) + ';height:' + px(g.matH) + ';background:#fff;box-shadow:' + (g.mat ? 'inset 0 0 0 1px #E1DED8, inset 0 1px 3px rgba(17,17,17,0.14)' : 'none') + ';padding:' + px(g.matPad) + ';box-sizing:border-box;">' +
          '<div style="width:100%;height:100%;background:#F1EFEB;overflow:hidden;"><img src="' + esc(prod.img) + '" alt="" draggable="false" style="width:100%;height:100%;object-fit:cover;display:block;"></div>' + sig +
        '</div></div></div>';
  }

  function render() {
    recomputeBox();
    var wallW = wallWcm();
    var k = ppcm();
    var px = function (v) { return Math.round(v * k * 10) / 10 + 'px'; };
    var custom = st.bg >= PRESETS.length;
    var m = st.measure;
    var mHasLine = m && m.p1 && m.p2;

    // catalog view switcher + filters
    var views = [['all', 'All Prints'], ['collections', 'Collections'], ['filters', 'Filters']];
    var viewsHtml = views.map(function (v) {
      var on = st.catView === v[0];
      return '<button type="button" data-wd-view="' + v[0] + '" style="padding:0 2px 12px;background:none;border:none;border-bottom:2px solid ' + (on ? '#111' : 'transparent') + ';margin-bottom:-1px;cursor:pointer;font-size:12.5px;font-weight:' + (on ? 600 : 400) + ';color:' + (on ? '#111' : '#8A8680') + ';">' + v[1] + '</button>';
    }).join('');
    var activeFilterCount = st.filterEd.length + st.filterSize.length + st.filterOrient.length + st.filterArtist.length + st.filterColor.length;
    var filterBar = activeFilterCount > 0
      ? '<div style="display:flex;align-items:center;justify-content:space-between;padding:10px 0 0;"><div style="font-size:11px;color:#8A8680;">' + activeFilterCount + ' filter' + (activeFilterCount === 1 ? '' : 's') + ' applied</div><button type="button" data-wd-clearfilters style="background:none;border:none;cursor:pointer;font-size:11px;color:#111;text-decoration:underline;text-underline-offset:2px;">Clear</button></div>'
      : '';

    function chipHtml(group, val, label, checked, swatch) {
      return '<button type="button" data-wd-chip="' + group + '" data-wd-val="' + esc(String(val)) + '" style="display:flex;align-items:center;gap:10px;background:none;border:none;padding:0;cursor:pointer;text-align:left;">' +
        '<span style="width:15px;height:15px;flex:0 0 auto;border:1px solid #111;background:' + (checked ? '#111' : '#fff') + ';display:flex;align-items:center;justify-content:center;">' + (checked ? '<span style="width:7px;height:7px;background:#fff;border-radius:1px;"></span>' : '') + '</span>' +
        (swatch ? '<span style="width:12px;height:12px;border-radius:50%;background:' + swatch + ';box-shadow:inset 0 0 0 1px rgba(17,17,17,0.15);flex:0 0 auto;"></span>' : '') +
        '<span style="font-size:13px;color:#111;">' + esc(label) + '</span></button>';
    }
    function accSection(key, title, chipsHtml) {
      var open = st.filterOpen[key];
      return '<div style="border-bottom:1px solid #ECEAE6;">' +
        '<button type="button" data-wd-acc="' + key + '" style="width:100%;display:flex;align-items:center;justify-content:space-between;padding:16px 0;background:none;border:none;cursor:pointer;">' +
        '<span style="font-size:11px;letter-spacing:0.16em;text-transform:uppercase;font-weight:600;color:#111;">' + title + '</span><span style="font-size:10px;color:#111;">' + (open ? '▲' : '▼') + '</span></button>' +
        (open ? '<div style="display:flex;flex-direction:column;gap:12px;padding-bottom:16px;">' + chipsHtml + '</div>' : '') + '</div>';
    }
    var filtersHtml = '';
    if (st.catView === 'filters') {
      filtersHtml += accSection('collection', 'Collection',
        [['limited', 'Limited Edition'], ['open', 'Open Edition']].map(function (e) { return chipHtml('ed', e[0], e[1], st.filterEd.indexOf(e[0]) >= 0, null); }).join(''));
      filtersHtml += accSection('size', 'Size',
        SIZES.map(function (s, i) { return chipHtml('size', i, s.name, st.filterSize.indexOf(i) >= 0, null); }).join(''));
      filtersHtml += accSection('artist', 'Artist',
        VENDORS.map(function (v) { return chipHtml('artist', v, v, st.filterArtist.indexOf(v) >= 0, null); }).join(''));
      filtersHtml += accSection('orientation', 'Orientation',
        [['v', 'Vertical'], ['h', 'Horizontal'], ['sq', 'Square']].map(function (o) { return chipHtml('orient', o[0], o[1], st.filterOrient.indexOf(o[0]) >= 0, null); }).join(''));
      if (AVAILABLE_COLORS.length) {
        filtersHtml += accSection('colors', 'Colors',
          AVAILABLE_COLORS.map(function (c) { return chipHtml('color', c, c.charAt(0).toUpperCase() + c.slice(1), st.filterColor.indexOf(c) >= 0, COLOR_PALETTE[c]); }).join(''));
      }
    }
    var collectionsPicker = '';
    if (st.catView === 'collections') {
      collectionsPicker = '<div style="margin-bottom:16px;"><select data-wd-col style="width:100%;padding:12px 14px;border:1px solid #111;font-size:13px;color:#111;background:#fff;cursor:pointer;">' +
        '<option value="">Choose a collection…</option>' +
        COLLECTIONS.map(function (c) { return '<option value="' + esc(c.h) + '"' + (st.catCollection === c.h ? ' selected' : '') + '>' + esc(c.t) + '</option>'; }).join('') +
        '</select></div>';
    }

    // wall items + props
    var itemsHtml = st.items.map(itemHtml).join('');
    var propsHtml = '';
    if (!custom && st.canvasH > 260) {
      propsHtml = (KITS[PRESETS[st.bg].kit] || []).map(function (sh) {
        return '<div style="position:absolute;left:calc(50% + ' + Math.round((sh.cx - sh.w / 2) * k) + 'px);bottom:calc(15% + ' + Math.round(sh.y * k) + 'px);width:' + px(sh.w) + ';height:' + px(sh.h) + ';background:' + sh.bg + ';border-radius:' + (sh.r || '0') + ';pointer-events:none;"></div>';
      }).join('');
    }

    // measure overlay
    var measureHtml = '';
    if (m) {
      if (mHasLine) {
        var dx = m.p2.x - m.p1.x, dy = m.p2.y - m.p1.y;
        measureHtml += '<div style="position:absolute;left:' + m.p1.x + 'px;top:' + m.p1.y + 'px;width:' + Math.round(Math.hypot(dx, dy)) + 'px;height:2px;background:#A38B5F;transform:rotate(' + (Math.round(Math.atan2(dy, dx) * 1800 / Math.PI) / 10) + 'deg);transform-origin:0 50%;pointer-events:none;z-index:40;"></div>';
      }
      [m.p1, m.p2].forEach(function (p) {
        if (p) measureHtml += '<div style="position:absolute;left:' + p.x + 'px;top:' + p.y + 'px;width:10px;height:10px;border-radius:50%;background:#A38B5F;border:2px solid #fff;transform:translate(-50%,-50%);pointer-events:none;z-index:41;"></div>';
      });
      if (mHasLine) {
        var ixm = Math.min(st.canvasW - 240, (m.p1.x + m.p2.x) / 2 - 100), iym = Math.min(st.canvasH - 110, (m.p1.y + m.p2.y) / 2 + 16);
        measureHtml += '<div data-wd-stop style="position:absolute;left:' + ixm + 'px;top:' + iym + 'px;background:#fff;box-shadow:0 12px 28px -12px rgba(17,17,17,0.35);padding:12px;z-index:42;">' +
          '<div style="font-size:10.5px;letter-spacing:0.14em;text-transform:uppercase;color:#8A8680;margin-bottom:8px;">This line is…</div>' +
          '<div style="display:flex;gap:6px;"><input data-wd-mval type="number" placeholder="e.g. 200" style="width:90px;padding:9px 10px;border:1px solid #111;font-size:13px;outline:none;">' +
          '<div style="align-self:center;font-size:12px;color:#8A8680;">cm</div>' +
          '<button type="button" data-wd-mset style="padding:9px 14px;background:#111;border:none;color:#fff;font-size:12px;font-weight:600;cursor:pointer;">Set</button></div></div>';
      } else {
        measureHtml += '<div style="position:absolute;top:16px;left:50%;transform:translateX(-50%);background:#111;color:#fff;padding:10px 18px;font-size:12px;letter-spacing:0.04em;z-index:42;pointer-events:none;">' + (m.p1 ? 'Click the end of your reference line' : 'Click the start of a line you know the length of (e.g. sofa width)') + '</div>';
      }
    }

    // selected panel
    var selItem = st.items.filter(function (it) { return it.id === st.sel; })[0];
    var selHtml = '';
    if (selItem) {
      var sProd = PRODUCTS[selItem.art];
      var sizeNoFrame = SIZES[selItem.sizeIdx].fw == null && sProd.ed === 'limited';
      var sizeBtns = sizesFor(sProd).map(function (x) {
        var on = x.i === selItem.sizeIdx;
        return '<button type="button" data-wd-selsize="' + x.i + '" style="padding:6px 9px;background:' + (on ? '#111' : '#fff') + ';border:1px solid ' + (on ? '#111' : '#E3E1DD') + ';cursor:pointer;font-size:10.5px;font-weight:' + (on ? 600 : 400) + ';color:' + (on ? '#fff' : '#111') + ';">' + esc(x.s.name) + '</button>';
      }).join('');
      var typeHtml = '';
      if (sProd.ed === 'open') {
        typeHtml = '<div style="font-size:10px;letter-spacing:0.16em;text-transform:uppercase;color:#8A8680;margin-bottom:7px;">Frame type</div><div style="display:flex;gap:5px;margin-bottom:13px;">' +
          [['classic', 'Classic'], ['box', 'Premium Shadow Box']].map(function (t) {
            var on = (selItem.ftype || 'classic') === t[0] && selItem.fin !== 'none';
            return '<button type="button" data-wd-seltype="' + t[0] + '" style="padding:6px 9px;background:' + (on ? '#111' : '#fff') + ';border:1px solid ' + (on ? '#111' : '#E3E1DD') + ';cursor:pointer;font-size:10.5px;font-weight:' + (on ? 600 : 400) + ';color:' + (on ? '#fff' : '#111') + ';">' + t[1] + '</button>';
          }).join('') + '</div>' +
          '<div style="font-size:10px;letter-spacing:0.16em;text-transform:uppercase;color:#8A8680;margin-bottom:7px;">White border</div><div style="display:flex;gap:5px;margin-bottom:13px;">' +
          [[true, 'Yes'], [false, 'No']].map(function (b) {
            var on = (selItem.border !== false) === b[0];
            return '<button type="button" data-wd-selborder="' + b[0] + '" style="padding:6px 9px;background:' + (on ? '#111' : '#fff') + ';border:1px solid ' + (on ? '#111' : '#E3E1DD') + ';cursor:pointer;font-size:10.5px;font-weight:' + (on ? 600 : 400) + ';color:' + (on ? '#fff' : '#111') + ';">' + b[1] + '</button>';
          }).join('') + '</div>';
      }
      var sizeName = SIZES[selItem.sizeIdx].name;
      var finBtns = FIN_KEYS.map(function (kk) {
        var disabled = (sizeNoFrame && kk !== 'none') || !finAvailable(sProd, sizeName, kk, selItem.ftype || 'classic');
        var on = selItem.fin === kk;
        return '<button type="button" data-wd-selfin="' + kk + '" ' + (disabled ? 'disabled' : '') + ' style="display:flex;align-items:center;gap:6px;padding:6px 9px;background:#fff;border:1px solid ' + (on ? '#111' : '#E3E1DD') + ';cursor:' + (disabled ? 'default' : 'pointer') + ';font-size:10.5px;font-weight:' + (on ? 600 : 400) + ';color:#111;opacity:' + (disabled ? 0.35 : 1) + ';">' +
          (kk === 'none' ? '' : '<span style="width:9px;height:9px;border-radius:50%;background:' + FIN[kk].bg + ';box-shadow:inset 0 0 0 1px rgba(17,17,17,0.18);"></span>') + FIN[kk].label + '</button>';
      }).join('');
      selHtml = '<div data-wd-stop style="position:absolute;top:14px;right:14px;width:250px;background:#fff;box-shadow:0 16px 40px -18px rgba(17,17,17,0.35);padding:16px;z-index:50;">' +
        '<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:4px;"><div style="font-size:13px;font-weight:600;">' + esc(sProd.title) + '</div><div style="font-size:12px;color:#8A8680;">' + money(itemPrice(selItem)) + '</div></div>' +
        (sProd.ed === 'limited' ? '<div style="font-size:10px;letter-spacing:0.14em;text-transform:uppercase;color:#A38B5F;margin-bottom:12px;">Limited Edition · ' + (selItem.editionNum || 1) + '/150 · Signed</div>' : '<div style="margin-bottom:12px;"></div>') +
        '<div style="font-size:10px;letter-spacing:0.16em;text-transform:uppercase;color:#8A8680;margin-bottom:7px;">Size</div>' +
        '<div style="display:flex;flex-wrap:wrap;gap:5px;margin-bottom:13px;">' + sizeBtns + '</div>' +
        typeHtml +
        '<div style="font-size:10px;letter-spacing:0.16em;text-transform:uppercase;color:#8A8680;margin-bottom:7px;">' + (sProd.ed === 'limited' ? 'Framing · Premium shadow box' : 'Frame colour') + '</div>' +
        (sizeNoFrame ? '<div style="font-size:10.5px;color:#8A8680;margin-bottom:10px;line-height:1.5;">Ships rolled at this size — professional mounting recommended.</div>' : '') +
        '<div style="display:flex;flex-wrap:wrap;gap:5px;margin-bottom:15px;">' + finBtns + '</div>' +
        '<div style="display:flex;gap:6px;"><button type="button" data-wd-dup class="wd2-mini-btn">Duplicate</button><button type="button" data-wd-remove class="wd2-mini-btn" style="color:#9A3B2E;">Remove</button></div></div>';
    }

    // background + wall colour rows
    var bgLabels = PRESETS.map(function (p) { return { label: p.label, sw: p.sw }; }).concat([{ label: 'Your photo', sw: '#FFFFFF' }]);
    var bgHtml = bgLabels.map(function (b, i) {
      return '<button type="button" data-wd-bg="' + i + '" style="display:flex;align-items:center;gap:7px;padding:8px 12px;background:#fff;border:1px solid ' + (st.bg === i ? '#111' : '#E3E1DD') + ';cursor:pointer;font-size:11.5px;font-weight:' + (st.bg === i ? 600 : 400) + ';color:#111;"><span style="width:12px;height:12px;border-radius:50%;background:' + b.sw + ';box-shadow:inset 0 0 0 1px rgba(17,17,17,0.14);"></span>' + b.label + '</button>';
    }).join('');
    var isCustomColor = st.wallColor && WALL_COLORS.indexOf(st.wallColor) < 0;
    var wallColorRow = !custom
      ? '<div class="wd2-wallcolors"><div class="wd2-bglabel">Wall colour</div>' +
        WALL_COLORS.map(function (c) {
          return '<button type="button" data-wd-wallcolor="' + c + '" style="width:26px;height:26px;border-radius:50%;background:' + c + ';border:2px solid ' + (st.wallColor === c ? '#111' : '#fff') + ';box-shadow:inset 0 0 0 1px rgba(17,17,17,0.08);cursor:pointer;padding:0;margin:0 3px;"></button>';
        }).join('') +
        '<input data-wd-customcolor type="color" value="' + (isCustomColor ? st.wallColor : '#FFFFFF') + '" style="width:26px;height:26px;border:2px solid ' + (isCustomColor ? '#111' : '#E3E1DD') + ';border-radius:50%;padding:0;cursor:pointer;background:none;overflow:hidden;margin-left:5px;">' +
        '</div>'
      : '';
    var roomBlurb = custom ? 'Use your own photo to see prints on your actual wall.' : PRESETS[st.bg].blurb;

    // scale badge (m + ft/in)
    var mWide = Math.round((wallW / 100) * 10) / 10;
    var totalIn = wallW / 2.54, ft = Math.floor(totalIn / 12), inch = Math.round(totalIn - ft * 12);
    var badge = st.canvasW < 220 ? (mWide + ' m wide') : ('Wall ≈ ' + mWide + ' m (' + ft + '′' + inch + '″) wide');

    var subtotal = st.items.reduce(function (acc, it) { return acc + itemPrice(it); }, 0);

    app.innerHTML =
      '<div class="wd2-top wd2-top--title"><div class="wd2-title">Wall designer</div><div class="wd2-title-sub">Arrange prints on a wall to scale, try sizes and framing, then export or share your design.</div></div>' +
      '<div class="wd2-main">' +
        '<div class="wd2-catalog">' +
          '<div class="wd2-catalog-head">' +
            '<input data-wd-search type="text" value="' + esc(st.search) + '" placeholder="Search prints">' +
            '<div class="wd2-tabs">' + viewsHtml + '</div>' + filterBar +
          '</div>' +
          (st.catView === 'filters'
            ? '<div class="wd-scroll" style="flex:1;overflow-y:auto;padding:4px 20px 24px;">' + filtersHtml + '</div>'
            : '<div class="wd2-catalog-grid wd-scroll">' + collectionsPicker +
              (st.catView === 'collections' && !st.catCollection
                ? '<div style="padding:20px 0;font-size:12.5px;color:#8A8680;">Choose a collection above to see its prints.</div>'
                : '<div class="wd2-grid-inner">' + catalogGridHtml() + '</div>') +
              '</div>') +
        '</div>' +
        '<div class="wd2-wallwrap">' +
          '<div class="wd2-bgbar-row"><div class="wd2-bgbar"><div class="wd2-bglabel">Background</div>' + bgHtml +
            (custom ? '<button type="button" data-wd-measure style="padding:8px 12px;background:#fff;border:1px solid #A38B5F;cursor:pointer;font-size:11.5px;font-weight:600;color:#A38B5F;">⟷ Measure wall</button>' : '') +
            (custom && st.customBgUrl ? '<label style="padding:8px 12px;background:#fff;border:1px solid #E3E1DD;cursor:pointer;font-size:11.5px;color:#111;">Change photo<input data-wd-bgfile type="file" accept="image/*" style="display:none;"></label>' : '') +
          '</div></div>' +
          '<div class="wd2-roomblurb">' + esc(roomBlurb) + '</div>' +
          wallColorRow +
          '<div class="wd2-canvas-wrap" data-wd-wrap>' +
            '<div class="wd2-canvas" data-wd-canvas style="width:' + st.canvasW + 'px;height:' + st.canvasH + 'px;background:' + (custom ? '#F1EFEB' : (st.wallColor || PRESETS[st.bg].wall)) + ';cursor:' + (m ? 'crosshair' : 'default') + ';">' +
              (!custom ? '<div style="position:absolute;left:0;right:0;bottom:0;height:15%;background:' + PRESETS[st.bg].floor + ';pointer-events:none;"></div><div style="position:absolute;left:0;right:0;bottom:15%;height:10px;background:#fff;box-shadow:0 1px 2px rgba(17,17,17,0.12);pointer-events:none;"></div>' : '') +
              propsHtml +
              (custom ? (st.customBgUrl
                ? '<img src="' + esc(st.customBgUrl) + '" alt="" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;pointer-events:none;">'
                : '<div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;"><label style="text-align:center;cursor:pointer;padding:40px;"><div style="font-family:var(--heading-font-family,serif);font-size:22px;font-weight:300;color:#8A8680;">Upload your wall photo</div><div style="font-size:12px;color:#B0ABA2;margin-top:8px;">JPG or PNG · straight-on photos work best</div><input data-wd-bgfile type="file" accept="image/*" style="display:none;"></label></div>') : '') +
              itemsHtml + measureHtml +
              (st.items.length === 0 && !m ? '<div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none;"><div style="text-align:center;"><div style="font-family:var(--heading-font-family,serif);font-size:26px;font-weight:300;color:#8A8680;">Your wall is empty</div><div style="font-size:12.5px;color:#B0ABA2;margin-top:8px;">Add prints from the left to begin</div></div></div>' : '') +
              selHtml +
              '<div style="position:absolute;left:14px;bottom:14px;background:#fff;padding:' + (st.canvasW < 220 ? '4px 7px' : '6px 10px') + ';font-size:' + (st.canvasW < 220 ? '8.5px' : '10px') + ';letter-spacing:0.16em;text-transform:uppercase;color:#8A8680;z-index:30;pointer-events:none;">' + badge + '</div>' +
            '</div>' +
          '</div>' +
          '<div class="wd2-bottom">' +
            '<button type="button" data-wd-clear style="padding:8px 12px;background:none;border:none;cursor:pointer;font-size:11.5px;color:#8A8680;text-decoration:underline;text-underline-offset:3px;">Clear wall</button>' +
            '<div class="wd2-top-actions">' +
              '<div class="wd2-subtotal">Subtotal <strong>' + money(subtotal) + '</strong></div>' +
              '<div style="position:relative;"><button type="button" class="wd2-btn" data-wd-dl>Download ▾</button>' +
                '<div style="display:' + (st.dlOpen ? 'block' : 'none') + ';position:absolute;bottom:calc(100% + 6px);right:0;background:#fff;border:1px solid #111;box-shadow:0 16px 32px -16px rgba(17,17,17,0.25);z-index:80;min-width:150px;">' +
                '<button type="button" class="wd2-menu-item" data-wd-jpg>JPG image</button>' +
                '<button type="button" class="wd2-menu-item" data-wd-pdf style="border-top:1px solid #ECEAE6;">PDF</button></div></div>' +
              '<button type="button" class="wd2-btn" data-wd-share>' + (st.shared ? 'Link copied ✓' : 'Share link') + '</button>' +
              '<button type="button" class="wd2-btn" data-wd-cart>' + (st.cartBusy ? 'Adding…' : (st.cartAdded ? 'Added ' + st.items.length + ' ✓' : 'Add all to cart')) + '</button>' +
              '<button type="button" class="wd2-btn wd2-btn--dark" data-wd-checkout>Checkout</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<img id="wd2-print" style="display:none;width:100%;">';

    wrapEl = app.querySelector('[data-wd-wrap]');
    canvasEl = app.querySelector('[data-wd-canvas]');
    if (recomputeBox()) render();
  }

  // ---------- canvas export ----------
  function buildCanvas(cb) {
    var W = 1800, H = Math.round(W * st.canvasH / st.canvasW);
    var k = W / wallWcm();
    var cv = document.createElement('canvas');
    cv.width = W; cv.height = H;
    var ctx = cv.getContext('2d');

    function drawItems() {
      var urls = {};
      st.items.forEach(function (it) { urls[PRODUCTS[it.art].img] = 1; });
      var list = Object.keys(urls), cache = {}, waiting = list.length;
      function done() {
        st.items.forEach(function (it) {
          var g = frameGeom(it), f = FIN[it.fin], prod = PRODUCTS[it.art];
          var x = it.x * k, y = it.y * k, w = g.w * k, h = g.h * k;
          ctx.save();
          ctx.shadowColor = 'rgba(17,17,17,0.35)'; ctx.shadowBlur = 18; ctx.shadowOffsetY = 10;
          ctx.fillStyle = f.bg; ctx.fillRect(x, y, w, h);
          ctx.restore();
          if (it.fin === 'none' || it.fin === 'white') { ctx.strokeStyle = '#D9D4C8'; ctx.lineWidth = 1; ctx.strokeRect(x, y, w, h); }
          var pad = g.framePad * k;
          ctx.fillStyle = '#fff'; ctx.fillRect(x + pad, y + pad, w - 2 * pad, h - 2 * pad);
          var mx = x + (w - g.matW * k) / 2, my = y + (h - g.matH * k) / 2;
          ctx.fillRect(mx, my, g.matW * k, g.matH * k);
          if (g.mat) { ctx.strokeStyle = '#E1DED8'; ctx.lineWidth = 1; ctx.strokeRect(mx, my, g.matW * k, g.matH * k); }
          var ix = mx + g.matPad * k, iy = my + g.matPad * k;
          var iw = (g.matW - 2 * g.matPad) * k, ih = (g.matH - 2 * g.matPad) * k;
          ctx.fillStyle = '#F1EFEB'; ctx.fillRect(ix, iy, iw, ih);
          var img = cache[prod.img];
          if (img && img.complete && img.naturalWidth) {
            var sc = Math.max(iw / img.naturalWidth, ih / img.naturalHeight);
            var sw2 = iw / sc, sh2 = ih / sc;
            ctx.drawImage(img, (img.naturalWidth - sw2) / 2, (img.naturalHeight - sh2) / 2, sw2, sh2, ix, iy, iw, ih);
          }
          if (prod.ed === 'limited') {
            var band = (g.sigBand || g.matPad) * k;
            var fs = Math.max(6, band * 0.38);
            var ty = my + g.matH * k - Math.max(0, (g.matPad * k - band)) - band / 2;
            ctx.fillStyle = '#55524D'; ctx.textBaseline = 'middle';
            ctx.font = fs + 'px Helvetica, sans-serif';
            ctx.textAlign = 'left'; ctx.fillText((it.editionNum || 1) + '/150', ix, ty);
            ctx.textAlign = 'center'; ctx.fillText(prod.title.toUpperCase(), mx + (g.matW * k) / 2, ty);
            ctx.textAlign = 'right'; ctx.font = 'italic ' + fs + 'px Georgia, serif';
            ctx.fillText(prod.vendor, ix + iw, ty);
          }
        });
        cb(cv);
      }
      if (!waiting) return done();
      list.forEach(function (u) {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () { if (--waiting === 0) done(); };
        im.onerror = function () { if (--waiting === 0) done(); };
        im.src = u; cache[u] = im;
      });
    }

    var custom = st.bg >= PRESETS.length;
    if (custom) {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, W, H);
      if (st.customBgUrl) {
        var bim = new Image();
        bim.onload = function () {
          var sc = Math.max(W / bim.naturalWidth, H / bim.naturalHeight);
          var sw2 = W / sc, sh2 = H / sc;
          ctx.drawImage(bim, (bim.naturalWidth - sw2) / 2, (bim.naturalHeight - sh2) / 2, sw2, sh2, 0, 0, W, H);
          drawItems();
        };
        bim.onerror = drawItems;
        bim.src = st.customBgUrl;
        return;
      }
      drawItems();
      return;
    }
    var p = PRESETS[st.bg];
    ctx.fillStyle = st.wallColor || p.wall; ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = p.floor; ctx.fillRect(0, H * 0.85, W, H * 0.15);
    ctx.fillStyle = '#fff'; ctx.fillRect(0, H * 0.85 - 12, W, 12);
    drawItems();
  }

  // ---------- cart ----------
  function addAllToCart(then) {
    if (!st.items.length || st.cartBusy) return;
    var lines = [];
    st.items.forEach(function (it) { lines = lines.concat(itemCartLines(it)); });
    if (!lines.length) return;
    st.cartBusy = true; render();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: lines })
    }).then(function (r) {
      st.cartBusy = false;
      if (!r.ok) throw new Error('cart');
      st.cartAdded = true; render();
      document.dispatchEvent(new CustomEvent('product:added', { bubbles: true }));
      setTimeout(function () { st.cartAdded = false; if (!then) render(); }, 2200);
      if (then) then();
    }).catch(function () {
      st.cartBusy = false; render();
      alert('Sorry — something went wrong adding to the cart. Please try again.');
    });
  }

  // ---------- share ----------
  function restoreFromHash() {
    try {
      if (!location.hash || location.hash.indexOf('#wd=') !== 0) return;
      var payload = JSON.parse(atob(location.hash.slice(4)));
      if (!payload || !payload.items) return;
      var items = [];
      payload.items.forEach(function (a, i) {
        var idx = -1;
        for (var j = 0; j < PRODUCTS.length; j++) { if (PRODUCTS[j].handle === a.h) { idx = j; break; } }
        if (idx < 0) return;
        items.push({ id: i + 1, art: idx, sizeIdx: a.s, fin: a.f, ftype: a.t || 'classic', border: a.b !== 0, editionNum: a.e || 1, x: a.x, y: a.y });
      });
      st.items = items; st.nextId = items.length + 1;
      st.bg = Math.min(payload.bg || 0, PRESETS.length);
      st.customWallWcm = payload.wcm || 400;
      if (payload.wc) st.wallColor = payload.wc;
    } catch (e) {}
  }
  function shareLink() {
    var payload = {
      items: st.items.map(function (it) {
        return { h: PRODUCTS[it.art].handle, s: it.sizeIdx, f: it.fin, t: it.ftype, b: it.border === false ? 0 : 1, e: it.editionNum || 1, x: Math.round(it.x * 10) / 10, y: Math.round(it.y * 10) / 10 };
      }),
      bg: st.bg, wcm: st.customWallWcm, wc: st.wallColor || undefined
    };
    history.replaceState(null, '', '#wd=' + btoa(JSON.stringify(payload)));
    var done = function () { st.shared = true; render(); setTimeout(function () { st.shared = false; render(); }, 2200); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(location.href).then(done).catch(done);
    else done();
  }

  // ---------- events (delegated, bound once) ----------
  function selItemGet() { return st.items.filter(function (it) { return it.id === st.sel; })[0]; }
  function upd(patch) {
    st.items = st.items.map(function (it) { return it.id === st.sel ? Object.assign({}, it, patch) : it; });
    render();
  }
  function switchWall(newBg) {
    var oldBg = st.bg, oldWcm = wallWcm(), oldH = wallHcmFor(oldBg);
    st.bg = newBg; st.measure = null;
    var newW = wallWcm(), newH = wallHcmFor(newBg);
    if (oldBg !== newBg && oldWcm && oldH && st.items.length) {
      var rx = newW / oldWcm, ry = newH / oldH;
      st.items = st.items.map(function (it) { return Object.assign({}, it, { x: it.x * rx, y: it.y * ry }); });
    }
    render();
  }

  function bind() {
    app.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-wd-view],[data-wd-acc],[data-wd-chip],[data-wd-clearfilters],[data-wd-add],[data-wd-bg],[data-wd-wallcolor],[data-wd-measure],[data-wd-clear],[data-wd-dl],[data-wd-jpg],[data-wd-pdf],[data-wd-share],[data-wd-cart],[data-wd-checkout],[data-wd-selsize],[data-wd-seltype],[data-wd-selborder],[data-wd-selfin],[data-wd-dup],[data-wd-remove],[data-wd-mset]');
      if (!t) { if (st.dlOpen) { st.dlOpen = false; render(); } return; }
      if (t.hasAttribute('data-wd-view')) { st.catView = t.getAttribute('data-wd-view'); render(); }
      else if (t.hasAttribute('data-wd-acc')) { var ak = t.getAttribute('data-wd-acc'); st.filterOpen[ak] = !st.filterOpen[ak]; render(); }
      else if (t.hasAttribute('data-wd-chip')) {
        var grp = t.getAttribute('data-wd-chip'), val = t.getAttribute('data-wd-val');
        var map = { ed: 'filterEd', size: 'filterSize', artist: 'filterArtist', orient: 'filterOrient', color: 'filterColor' };
        var arrName = map[grp];
        if (arrName) {
          var v2 = grp === 'size' ? +val : val;
          var arr = st[arrName];
          st[arrName] = arr.indexOf(v2) >= 0 ? arr.filter(function (x) { return x !== v2; }) : arr.concat([v2]);
          render();
        }
      }
      else if (t.hasAttribute('data-wd-clearfilters')) { st.filterEd = []; st.filterSize = []; st.filterArtist = []; st.filterOrient = []; st.filterColor = []; render(); }
      else if (t.hasAttribute('data-wd-add')) {
        var ai = +t.getAttribute('data-wd-add');
        var prod = PRODUCTS[ai];
        var avail = sizesFor(prod);
        var want = st.filterSize.length ? st.filterSize[0] : 2;
        var sizeIdx = avail.some(function (x) { return x.i === want; }) ? want : (avail.some(function (x) { return x.i === 2; }) ? 2 : (avail[0] ? avail[0].i : 0));
        var fin = finAvailable(prod, SIZES[sizeIdx].name, 'oak', 'classic') ? 'oak' : 'none';
        var g = frameGeom({ art: ai, sizeIdx: sizeIdx, fin: fin, ftype: 'classic' });
        var wallW2 = wallWcm(), wallH2 = wallW2 * (st.canvasH / st.canvasW || 0.62);
        var margin = Math.max(10, wallW2 * 0.02);
        var x = wallW2 / 2 - g.w / 2, y = wallH2 * 0.42 - g.h / 2, tries = 0;
        function overlaps(cx, cy) {
          return st.items.some(function (it) {
            var og = frameGeom(it);
            return cx < it.x + og.w + margin && cx + g.w + margin > it.x && cy < it.y + og.h + margin && cy + g.h + margin > it.y;
          });
        }
        while (overlaps(x, y) && tries < 40) {
          x += g.w * 0.55 + margin;
          if (x + g.w > wallW2 - margin) { x = margin; y += g.h * 0.55 + margin; }
          tries++;
        }
        var id = st.nextId++;
        st.items.push({ id: id, art: ai, sizeIdx: sizeIdx, fin: fin, ftype: 'classic', border: true, editionNum: Math.floor(Math.random() * 150) + 1, x: x, y: y });
        st.sel = id; render();
      }
      else if (t.hasAttribute('data-wd-bg')) switchWall(+t.getAttribute('data-wd-bg'));
      else if (t.hasAttribute('data-wd-wallcolor')) { st.wallColor = t.getAttribute('data-wd-wallcolor'); render(); }
      else if (t.hasAttribute('data-wd-measure')) { st.measure = {}; st.sel = null; render(); }
      else if (t.hasAttribute('data-wd-clear')) { st.items = []; st.sel = null; render(); }
      else if (t.hasAttribute('data-wd-dl')) { st.dlOpen = !st.dlOpen; render(); }
      else if (t.hasAttribute('data-wd-jpg')) {
        st.dlOpen = false; render();
        buildCanvas(function (cv) { cv.toBlob(function (b) { var a = document.createElement('a'); a.href = URL.createObjectURL(b); a.download = 'wall-design.jpg'; a.click(); }, 'image/jpeg', 0.92); });
      }
      else if (t.hasAttribute('data-wd-pdf')) {
        st.dlOpen = false; render();
        buildCanvas(function (cv) { var img = document.getElementById('wd2-print'); if (img) { img.src = cv.toDataURL('image/jpeg', 0.92); setTimeout(function () { window.print(); }, 350); } });
      }
      else if (t.hasAttribute('data-wd-share')) shareLink();
      else if (t.hasAttribute('data-wd-cart')) addAllToCart(null);
      else if (t.hasAttribute('data-wd-checkout')) addAllToCart(function () { window.location.href = '/checkout'; });
      else if (t.hasAttribute('data-wd-selsize')) {
        var si = +t.getAttribute('data-wd-selsize');
        var sel = selItemGet();
        if (sel) {
          var patch = { sizeIdx: si };
          if (SIZES[si].fw == null && PRODUCTS[sel.art].ed === 'limited') patch.fin = 'none';
          else if (!finAvailable(PRODUCTS[sel.art], SIZES[si].name, sel.fin, sel.ftype || 'classic')) patch.fin = 'none';
          upd(patch);
        }
      }
      else if (t.hasAttribute('data-wd-seltype')) {
        var sel2 = selItemGet();
        if (sel2) upd(sel2.fin === 'none' ? { ftype: t.getAttribute('data-wd-seltype'), fin: 'oak' } : { ftype: t.getAttribute('data-wd-seltype') });
      }
      else if (t.hasAttribute('data-wd-selborder')) upd({ border: t.getAttribute('data-wd-selborder') === 'true' });
      else if (t.hasAttribute('data-wd-selfin')) upd({ fin: t.getAttribute('data-wd-selfin') });
      else if (t.hasAttribute('data-wd-dup')) {
        var sel3 = selItemGet();
        if (sel3) { var nid = st.nextId++; st.items.push(Object.assign({}, sel3, { id: nid, x: sel3.x + 12, y: sel3.y + 12, editionNum: Math.floor(Math.random() * 150) + 1 })); st.sel = nid; render(); }
      }
      else if (t.hasAttribute('data-wd-remove')) { st.items = st.items.filter(function (it) { return it.id !== st.sel; }); st.sel = null; render(); }
      else if (t.hasAttribute('data-wd-mset')) {
        var inp = app.querySelector('[data-wd-mval]');
        var cm = inp ? parseFloat(inp.value) : 0;
        var mm = st.measure;
        if (cm && mm && mm.p1 && mm.p2) {
          var distPx = Math.hypot(mm.p2.x - mm.p1.x, mm.p2.y - mm.p1.y);
          var oldWcm = st.customWallWcm;
          st.customWallWcm = Math.round((st.canvasW / (distPx / cm)) * 10) / 10;
          if (oldWcm && st.items.length) {
            var r = st.customWallWcm / oldWcm;
            st.items = st.items.map(function (it) { return Object.assign({}, it, { x: it.x * r, y: it.y * r }); });
          }
          st.measure = null;
          render();
        }
      }
    });

    app.addEventListener('input', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-wd-search')) {
        st.search = e.target.value;
        var grid = app.querySelector('.wd2-grid-inner');
        if (grid) grid.innerHTML = catalogGridHtml();
      }
      if (e.target.hasAttribute && e.target.hasAttribute('data-wd-customcolor')) {
        st.wallColor = e.target.value;
        if (canvasEl && st.bg < PRESETS.length) canvasEl.style.background = st.wallColor;
      }
    });

    app.addEventListener('change', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-wd-bgfile')) {
        var f = e.target.files && e.target.files[0];
        if (!f) return;
        var rd = new FileReader();
        rd.onload = function () { st.customBgUrl = rd.result; render(); };
        rd.readAsDataURL(f);
      }
      if (e.target.hasAttribute && e.target.hasAttribute('data-wd-col')) { st.catCollection = e.target.value; render(); }
      if (e.target.hasAttribute && e.target.hasAttribute('data-wd-customcolor')) { st.wallColor = e.target.value; render(); }
    });

    // drag + canvas interactions
    app.addEventListener('pointerdown', function (e) {
      var stop = e.target.closest && e.target.closest('[data-wd-stop]');
      if (stop) return;
      var itEl = e.target.closest && e.target.closest('[data-wd-item]');
      if (itEl && !st.measure) {
        e.preventDefault();
        var id = +itEl.getAttribute('data-wd-item');
        var it = st.items.filter(function (x) { return x.id === id; })[0];
        if (!it) return;
        var r = canvasEl.getBoundingClientRect();
        drag = { id: id, dx: (e.clientX - r.left) / ppcm() - it.x, dy: (e.clientY - r.top) / ppcm() - it.y, moved: false };
        if (st.sel !== id) { st.sel = id; render(); }
        return;
      }
      if (canvasEl && (e.target === canvasEl || canvasEl.contains(e.target))) {
        var r2 = canvasEl.getBoundingClientRect();
        var p = { x: e.clientX - r2.left, y: e.clientY - r2.top };
        if (st.measure) {
          if (!st.measure.p1) { st.measure = { p1: p }; render(); }
          else if (!st.measure.p2) { st.measure = { p1: st.measure.p1, p2: p }; render(); }
          return;
        }
        if (st.sel != null) { st.sel = null; render(); }
      }
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag || !canvasEl) return;
      var r = canvasEl.getBoundingClientRect();
      var k = ppcm();
      var x = (e.clientX - r.left) / k - drag.dx;
      var y = (e.clientY - r.top) / k - drag.dy;
      drag.moved = true;
      var el = app.querySelector('[data-wd-item="' + drag.id + '"]');
      if (el) { el.style.left = Math.round(x * k * 10) / 10 + 'px'; el.style.top = Math.round(y * k * 10) / 10 + 'px'; }
      drag.x = x; drag.y = y;
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return;
      if (drag.moved && drag.x != null) {
        var id = drag.id, x = drag.x, y = drag.y;
        st.items = st.items.map(function (it) { return it.id === id ? Object.assign({}, it, { x: x, y: y }) : it; });
      }
      drag = null;
    });

    window.addEventListener('resize', function () { sizeApp(); if (recomputeBox()) render(); });
  }

  // ---------- boot ----------
  function sizeApp() {
    var h = Math.max(620, window.innerHeight - Math.max(0, app.getBoundingClientRect().top));
    app.style.height = h + 'px';
  }

  function boot() {
    if (window.innerWidth < 1024) return; // mobile: CSS shows the notice
    if (!PRODUCTS.length) {
      root.insertAdjacentHTML('beforeend', '<p style="padding:40px;text-align:center;color:#8A8680;">No products configured yet — set the Limited edition and Open edition collections on this section in the theme editor.</p>');
      return;
    }
    app = document.createElement('div');
    app.className = 'wd2-app';
    root.appendChild(app);
    restoreFromHash();
    render();
    bind();
    sizeApp();
    setTimeout(function () { if (recomputeBox()) render(); }, 60);
    setTimeout(function () { if (recomputeBox()) render(); }, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
